var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Color } from '../const';
import { BaseTooltipContainer, BaseTooltipArrow } from './util';
import Tooltip from './tooltip';
function DarkTooltip(props) {
    return (React.createElement(Tooltip, __assign({}, props, { CustomArrow: StyledArrow, CustomTooltipContainer: ToolTipContainer })));
}
var ToolTipContainer = styled(BaseTooltipContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n"], ["\n  background: ", ";\n  color: ", ";\n"])), Color.VERY_DARK_GRAY, Color.WHITE);
var StyledArrow = styled(BaseTooltipArrow)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), Color.VERY_DARK_GRAY);
export default DarkTooltip;
var templateObject_1, templateObject_2;
//# sourceMappingURL=dark-tooltip.js.map